var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"loading-section"},[(_vm.type === 'bubble')?_c('am2-loading-bubble',{style:(_vm.iconStyle)}):_vm._e(),_vm._v(" "),(_vm.type === 'spinner')?_c('am2-loading-spinner',{style:(_vm.iconStyle)}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }